import { ButtonGroup } from 'components/Form/ButtonGroup';
import { Toast } from 'components/Toast';
import { ToastValues } from 'components/ToastValues';
import { useAuth } from 'hooks/auth';
import { useModal } from 'hooks/modal';
import { useSpinner } from 'hooks/spinner';
import { useToast } from 'hooks/toast';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import api from 'services/api';
import { TiposSituacoes } from 'utils/enum';
import { formaPagamentoSelecionadaProps, protocoloProps } from 'utils/types';
import ButtonLink from 'components/ButtonLink';
import { Confirmacao } from '../Confirmacao';

import { Container, ContentImage, ContentInfo, ContentErro, ButtonGerarBoleto } from './styles';

interface dataPixProps {
  Emv: string;
  GuidProtocolo: string;
  ImagemBase64: string;
  Txid: string;
}

const schemaDataPix = {
  Emv: '',
  GuidProtocolo: '',
  ImagemBase64: '',
  Txid: '',
};

export const QrCodePix: React.FC = () => {
  const [dataPix, setDataPix] = useState<dataPixProps>();
  const [verificarSituacao, setVerificarSituacao] = useState<any>();
  const [erroProtocolo, setErroProtocolo] = useState(false);
  const [pago, setPago] = useState(false);

  const protocoloPagamento = JSON.parse(
    sessionStorage.getItem('@CheckoutWeb:protocoloPagamento') ?? '',
  ) as protocoloProps;

  const selectPayment = JSON.parse(
    sessionStorage.getItem('@CheckoutWeb:formaPagamento') ?? '',
  ) as formaPagamentoSelecionadaProps;

  const { loading, setLoading } = useSpinner();
  const { showModal } = useModal();
  const { getTotalSeconds } = useAuth();
  const { addToast } = useToast();

  const history = useHistory();

  const pathPagamento = history.location.pathname;

  useEffect(() => {
    sessionStorage.setItem('@CheckoutWeb:escolheuForma', 'true');
  }, []);

  const resetarPagamento = useCallback(() => {
    window.stop();
    clearTimeout(verificarSituacao);
    setVerificarSituacao({});
    history.goBack();
  }, [history, verificarSituacao]);

  const handleSituationGuid = useCallback(async () => {
    if (pathPagamento !== '/pagamento') {
      clearTimeout(verificarSituacao);
      setVerificarSituacao({});
      return;
    }

    await api
      .get(`Protocolo/${protocoloPagamento.GuidProtocolo}/situacao`)
      .then(result => {
        const { Data } = result.data;
        
        if (Data.SituacaoProtocolo === TiposSituacoes.concluido) {
          clearTimeout(verificarSituacao);
          setVerificarSituacao({});
          setPago(true);
          return;
        }

        if (
          Data.SituacaoProtocolo === TiposSituacoes.iniciado ||
          Data.SituacaoProtocolo === TiposSituacoes.emAndamento
        ) {
          setVerificarSituacao(
            setTimeout(() => {
              handleSituationGuid();
            }, 10000),
          );
        }
      })
      .catch((error: Error) => {
        if (error.message === 'Request aborted') {
          return;
        }
        resetarPagamento();
        addToast({
          type: 'danger',
          title: 'Atenção',
          description: error.message,
        });
      });
  }, [addToast, protocoloPagamento.GuidProtocolo, showModal]);

  const handleGetDataPix = useCallback(async () => {
    setLoading(true);
    setDataPix(schemaDataPix);
    clearTimeout(verificarSituacao);
    setVerificarSituacao({});
    await api
      .get(
        `/Protocolo/${protocoloPagamento.GuidProtocolo}/pix/${selectPayment.Id}`,
      )
      .then(result => {
        const { Data } = result.data;
        setDataPix(Data);
        handleSituationGuid();
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        window.stop();
        clearTimeout(verificarSituacao);
        setVerificarSituacao({});
        setErroProtocolo(true);
        addToast({
          type: 'danger',
          title: 'Atenção',
          description: error.message,
        });
      });
  }, [
    setLoading,
    protocoloPagamento.GuidProtocolo,
    selectPayment.Id,
    handleSituationGuid,
    addToast,
  ]);

  useEffect(() => {
    clearTimeout(verificarSituacao);
    setVerificarSituacao({});
  }, []);

  useEffect(() => {
    getTotalSeconds();
  }, [getTotalSeconds]);

  useEffect(() => {
    handleGetDataPix();
  }, [handleGetDataPix]);

  return (
    <Container>
      {pago ? (
        <Confirmacao />
      ) : (
      <div>
        {dataPix?.ImagemBase64 ? (
          <>
            <div className="mb-4">
              <ToastValues payment={selectPayment} />
            </div>
            <ContentImage>
              <ContentInfo>
                <p id="info">Pagar com PIX libera o seu</p> <p> limite de crédito em poucos minutos</p>
              </ContentInfo>
              <div id="mainContent">
                <div id="contentQrCode">
                  <img
                    src={`data:image/png;base64,${dataPix.ImagemBase64}`}
                    alt="qrCode"
                  />
                </div>
                <div className="d-flex justify-content-center mb-3">
                  <button
                    type="button"
                    onClick={() => {
                      addToast({
                        type: 'info',
                        title: 'Atenção',
                        description: 'Chave copiada com sucesso',
                      });
                      navigator.clipboard.writeText(dataPix.Emv);
                    }}
                  >
                    <b>COPIAR CHAVE PIX</b>
                  </button>
                </div>
              </div>
            </ContentImage>
            <ButtonGroup align="center">
            <ButtonLink />
              
            </ButtonGroup>
          </>
        ) : (
          <>
            {!loading && erroProtocolo && (
              <ContentErro>
                <div>
                  <Toast
                    title="Atenção"
                    textInfo="Falha ao tentar gerar Qrcode, clique no botão abaixo para gerar um novo Qrcode."
                    type="danger"
                  />
                  <ButtonGerarBoleto title="gerar qrcode" onClick={handleGetDataPix} >GERAR QRCODE</ ButtonGerarBoleto>

                  <ButtonLink />

                </div>
              </ContentErro>
            )}
          </>
        )}
      </div>
      )}
    </Container>
  );
};
